import React from "react";

export default function Loader({ size = "8", color = "blue" }) {
  // Map colors to Tailwind border classes
  const colorClass =
    {
      blue: "border-blue-600",
      green: "border-green-600",
      red: "border-red-600",
      yellow: "border-yellow-500",
      purple: "border-purple-600",
      white: "border-white",
      gray: "border-gray-600",
    }[color] || "border-blue-600"; // fallback to blue

  return (
    <div className="flex items-center justify-center">
      <div
        className={`animate-spin rounded-full h-${size} w-${size} border-4 border-t-transparent ${colorClass}`}
      />
    </div>
  );
}
